import { Component } from '@angular/core';
import { ClientPhotoComponent } from '@components/base/client/client-photo/client-photo';

@Component({
	selector: 'client-photo',
	template: require('./client-photo.html'),
	styles: [require('./client-photo.scss')]
})
export class ClientPhotoWebComponent extends ClientPhotoComponent {
	showModal(): void {
		$('#uploadPhotoModal').modal('show');
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/client/client-photo/client-photo.ts